import { INSTALLMENT_FEES } from "./installmentsFee";

export function calcCreditTotal({
  subtotal,
  shipping,
  installments,
}) {
  // const baseTotal = subtotal + shipping;
  const baseTotal = subtotal;

  const feeRate = INSTALLMENT_FEES[installments] || 0;
  const feeValue = baseTotal * feeRate;
  const finalTotal = baseTotal + feeValue;

  return {
    total: Number(finalTotal.toFixed(2)),
    fee: feeRate,
    feeValue: Number(feeValue.toFixed(2)),
  };
}